import { h } from 'preact';
import type { BusinessIconImageProps } from '../businessTypes';

type PaypalProps = Omit<BusinessIconImageProps, 'color' | 'secondaryColor' | 'strokeWidth'>;

const Paypal = ({ size = 24, width, height, alt = '', style, ...props }: PaypalProps) =>
  h(
    'svg',
    {
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
      width: width ?? size,
      height: height ?? size,
      role: alt ? 'img' : undefined,
      'aria-label': alt || undefined,
      'aria-hidden': alt ? undefined : true,
      style,
      ...props,
    },
    [
      h(
        'g',
        {
          transform: 'translate(-2.595102 -2.1) scale(1.175)',
        },
        [
          h(
            'path',
            {
              d: 'M19.1784 7.08179C19.1596 7.19993 19.1382 7.32149 19.1142 7.44648C18.3 11.655 15.5126 13.1095 11.9538 13.1095H10.1415C9.93082 13.11 9.7273 13.1859 9.56776 13.3235C9.40821 13.461 9.30319 13.6512 9.27169 13.8595L8.34369 19.7828L8.08087 21.4607C8.07069 21.527 8.07486 21.5946 8.09308 21.6591C8.1113 21.7236 8.14316 21.7835 8.1865 21.8346C8.22984 21.8857 8.28365 21.9269 8.34429 21.9555C8.40493 21.984 8.471 21.9992 8.53802 22H11.7526C11.9372 21.9996 12.1155 21.9333 12.2555 21.8131C12.3955 21.6928 12.4879 21.5266 12.5163 21.3443L12.548 21.1799L13.1532 17.3147L13.1926 17.1032C13.2206 16.9206 13.3129 16.7539 13.4529 16.6334C13.5929 16.5128 13.7715 16.4462 13.9562 16.4457H14.4365C17.551 16.4457 19.9891 15.1727 20.7014 11.4907C20.9993 9.95226 20.8452 8.66727 20.0576 7.76409C19.8082 7.48501 19.51 7.25378 19.1775 7.08179H19.1784Z',
              fill: '#179BD7',
            },
          ),
          h(
            'path',
            {
              d: 'M18.3258 6.73937C18.0655 6.66384 17.8007 6.60493 17.533 6.56302C17.0045 6.48128 16.4703 6.44206 15.9355 6.44573H11.0943C10.9095 6.44591 10.7308 6.51233 10.5907 6.63295C10.4506 6.75358 10.3584 6.92041 10.3307 7.10321L9.30084 13.6686L9.27173 13.8595C9.30322 13.6512 9.40825 13.4611 9.56779 13.3235C9.72734 13.1859 9.93086 13.11 10.1415 13.1096H11.9539C15.5126 13.1096 18.3001 11.6542 19.1142 7.4465C19.139 7.32151 19.1596 7.19995 19.1776 7.08181C18.9066 6.93778 18.621 6.82299 18.3258 6.73937Z',
              fill: '#222D65',
            },
          ),
          h(
            'path',
            {
              d: 'M10.3306 7.10231C10.3581 6.91952 10.4503 6.75268 10.5905 6.63217C10.7307 6.51165 10.9094 6.44548 11.0943 6.44569H15.9355C16.5091 6.44569 17.045 6.48335 17.5329 6.56297C17.8642 6.61519 18.1904 6.69395 18.5089 6.79754C18.7486 6.87716 18.972 6.97218 19.1783 7.08176C19.4206 5.52624 19.1766 4.46726 18.3402 3.50758C17.4191 2.45202 15.7565 2 13.6292 2H7.4516C7.01756 2 6.64687 2.31847 6.57924 2.75079L4.00668 19.1646C3.99455 19.2408 3.99897 19.3187 4.01966 19.393C4.04034 19.4673 4.07679 19.5363 4.12654 19.5953C4.22756 19.7134 4.3748 19.7819 4.52976 19.7827H8.34365L9.30076 13.6685L10.3306 7.10231Z',
              fill: '#253B80',
            },
          ),
        ],
      ),
    ],
  );

export default Paypal;
